import React, { useEffect, useState } from "react";
import {
  TextField,
  InputAdornment,
  styled,
  Box,
  Typography,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import VerifyOtp from "./VerifyOtp";
import InputField from "./InputField";
import { formatTime } from "../../utils/formatTime";
import { api, post } from "../../utils/api";

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
}));

const PhoneField = ({
  title,
  value,
  fieldName,
  placeholder,
  element,
  countryCode,
  setFormData,
  formData,
  showIcon,
  setErrors,
  errors,
  verify,
  disable,
  setVerify,
  verifybtn,
  setverifybtn,
  TaskAltIcons,
  handleChange,
  setTaskAltIcons,
}) => {
  const [otp, setOTP] = useState({ phone: "" });
  const [timerPhone, setTimerPhone] = useState(120);
  const [timerActive, setTimerActive] = useState({ phone: false });

  // Timer logic
  useEffect(() => {
    if (timerActive.phone && timerPhone > 0) {
      const timer = setInterval(() => {
        setTimerPhone((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            setTimerActive((prev) => ({ ...prev, phone: false }));
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [timerActive.phone, timerPhone]);

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    if (/^\d{0,10}$/.test(inputValue)) {
      handleChange(event);
    }
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;

    // Reset related states
    setTaskAltIcons((prev) => ({ ...prev, phone: false }));
    setVerify((prev) => ({ ...prev, phone: false, phoneMsg: "" }));
    setverifybtn((prev) => ({ ...prev, phone: false }));
    setTimerPhone(120);

    setErrors((prev) => ({
      ...prev,
      contactNumber: "",
      contactPersonName: "",
    }));

    if (formData?.contactNumber?.countryCode === "" || formData?.countryCode==="") {
      setErrors((prev) => ({
        ...prev,
        contactNumber: "Please Select Country.",
      }));
      return;
    }

    setOTP((prevOtp) => ({
      ...prevOtp,
      phone: "",
    }));

    const phoneNumberPattern = /^[0-9]{0,10}$/;
    if (!phoneNumberPattern.test(value)) {
      setErrors((prev) => ({
        ...prev,
        contactNumber: "Please Enter 0 - 9 digit only.",
      }));
      return;
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      contactNumber: {
        ...prevFormData.contactNumber,
        mobileNo: value,
      },
    }));

    if (value === element?.contactNumber.mobileNo) {
      setTaskAltIcons((prev) => ({ ...prev, phone: true }));
      return;
    }

    if (value.length === 10) {
      setverifybtn((prev) => ({ ...prev, phone: true }));
    }
  };

  const handleVerifyPhone = async (timePhone) => {
    if (timePhone > 0) {
      setverifybtn((prev) => ({ ...prev, phone: false }));
      setErrors((prev) => ({ ...prev, contactNumber: "" }));
      setTimerActive((prev) => ({ ...prev, phone: true }));
      try {
        await post(`/auth/sendOtpToPhone`, {
          phone: formData.contactNumber.mobileNo,
          countryCode: formData.contactNumber.countryCode,
          module: "Purchase",
        });
        setVerify((prev) => ({ ...prev, phone: true, phoneMsg: "" }));
      } catch (err) {
        if (err.response?.data?.statusCode === false) {
          setErrors((prev) => ({
            ...prev,
            contactNumber: "Mobile Number already registered.",
          }));
        }
      }
    } else {
      setVerify((prev) => ({ ...prev, phone: false }));
      setverifybtn((prev) => ({ ...prev, phone: false }));
    }
  };

  const handleOTPVerifyPhone = async (e) => {
    const { value } = e.target;
    const isNumeric = /^\d+$/.test(value) || value === "";
    if (isNumeric && value.length <= 4) {
      setVerify((prev) => ({ ...prev, phoneMsg: "" }));
      setOTP((prev) => ({ ...prev, phone: value }));

      if (value.length === 4) {
        await post(`${api}/auth/verifyOtpForPhone`, {
          phone: formData?.contactNumber.mobileNo,
          countryCode: formData?.contactNumber.countryCode,
          otp: value,
        })
          .then((res) => {
            setVerify((prev) => ({ ...prev, phone: false, phoneMsg: "" }));
            setverifybtn((prev) => ({ ...prev, phone: false }));
            setTaskAltIcons((prev) => ({ ...prev, phone: true }));
            setErrors((prev) => ({ ...prev, contactNumber: "" }));
          })
          .catch(() => {
            setVerify((prev) => ({ ...prev, phoneMsg: "Invalid OTP" }));
            setTaskAltIcons((prev) => ({ ...prev, phone: false }));
          });
      }
    }
  };

  const handleResendPhone = () => {
    setTimerPhone(120);
    setTimerActive((prev) => ({ ...prev, phone: true }));
    handleVerifyPhone(120);
  };

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
        {title}
      </Typography>
      <CustomTextField
        variant="outlined"
        fullWidth
        value={value}
        name={fieldName}
        placeholder={placeholder}
        onChange={handleChange}
        disabled={disable}
        InputProps={{
          maxLength: 10,
          inputMode: "numeric",
          pattern: "[0-9]*",
          endAdornment: showIcon && <TaskAltIcon sx={{ color: "green" }} />,
          startAdornment: (
            <InputAdornment position="start">
              <div
                style={{
                  width: "40px",
                  marginRight: "8px",
                  fontWeight: "bold",
                }}
              >
                {countryCode || "code"}
              </div>
              <div
                style={{
                  borderRight: "1px solid #000",
                  height: "24px",
                  marginRight: "8px",
                }}
              />
            </InputAdornment>
          ),
        }}
      />
      {errors && (
        <Typography variant="body2" color="#D34040">
          {errors}
        </Typography>
      )}
      {/* {verifybtn.phone && formData?.contactNumber?.mobileNo && (
        <VerifyOtp handleChange={() => handleVerifyPhone(120)} text="Verify" />
      )} */}
      {verify.phone && formData?.contactNumber?.mobileNo && (
        <Box>
          <InputField
            value={otp.phone}
            title="Enter OTP For Phone"
            handleChange={handleOTPVerifyPhone}
            name="otpPhone"
            placeholder="Enter OTP"
            inputProps={{
              maxLength: 4,
              inputMode: "numeric",
              pattern: "[0-9]*",
            }}
          />
          <Typography variant="body2" color="#D34040">
            {verify.phoneMsg}
          </Typography>
          {timerActive.phone ? (
            <Typography sx={{ textAlign: "right" }}>
              {formatTime(timerPhone)}
            </Typography>
          ) : (
            <VerifyOtp handleChange={() => handleResendPhone()} text="Resend" />
          )}
        </Box>
      )}
    </Box>
  );
};

export default PhoneField;
